var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5Z",
    fill: "#ACACAC",
    className: "app-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4832 10.4911C23.9944 9.79451 22.4024 9.28826 20.7381 9C20.5337 9.36954 20.2949 9.86659 20.1303 10.262C18.3611 9.99592 16.6081 9.99592 14.8714 10.262C14.7068 9.86659 14.4626 9.36954 14.2564 9C12.5903 9.28826 10.9965 9.79637 9.50768 10.4948C6.5047 15.0327 5.69064 19.4579 6.09767 23.8202C8.08941 25.3076 10.0196 26.2112 11.9173 26.8024C12.3858 26.1576 12.8037 25.4721 13.1637 24.7496C12.4781 24.4891 11.8214 24.1676 11.2009 23.7944C11.3656 23.6724 11.5266 23.5449 11.6821 23.4137C15.4666 25.1838 19.5785 25.1838 23.3178 23.4137C23.4752 23.5449 23.6362 23.6724 23.799 23.7944C23.1767 24.1694 22.5182 24.4909 21.8326 24.7515C22.1926 25.4721 22.6087 26.1594 23.079 26.8042C24.9785 26.213 26.9105 25.3095 28.9022 23.8202C29.3798 18.7632 28.0864 14.3786 25.4832 10.4911ZM13.6793 21.1374C12.5432 21.1374 11.6116 20.0768 11.6116 18.7853C11.6116 17.4938 12.5233 16.4314 13.6793 16.4314C14.8353 16.4314 15.7669 17.4919 15.747 18.7853C15.7488 20.0768 14.8353 21.1374 13.6793 21.1374ZM21.3206 21.1374C20.1846 21.1374 19.2529 20.0768 19.2529 18.7853C19.2529 17.4938 20.1646 16.4314 21.3206 16.4314C22.4766 16.4314 23.4082 17.4919 23.3883 18.7853C23.3883 20.0768 22.4766 21.1374 21.3206 21.1374Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDiscord);
export default __webpack_public_path__ + "static/media/footer_discord.a0274de77e3684d72508ffde7e541978.svg";
export { ForwardRef as ReactComponent };